import src from "IMAGE";
export default { src, width: 93, height: 93, blurWidth: 0, blurHeight: 0};
